import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';

var _tooltips;
var tooltips = (_tooltips = {}, _defineProperty(_tooltips, THEME_UI_DEFAULT_KEY, {
  variant: 'text.body',
  bg: 'white',
  borderRadius: 'default',
  color: 'text',
  px: 'sm',
  py: 'xs',
  fontSize: 'xs',
  wordWrap: 'break-word',
  boxShadow: 'defaultRise',
  elevation: 200
}), _defineProperty(_tooltips, "title", {
  variant: 'text.body',
  bg: 'gray.dark',
  // match chrome default title tooltip back ground
  color: 'neutral.light',
  borderRadius: 'none',
  fontSize: '0.6em',
  letterSpacing: '0.05em',
  py: '0.25em',
  px: '0.5em',
  wordWrap: 'break-word',
  maxWidth: '500px',
  border: 'neutral.light'
}), _defineProperty(_tooltips, "pendo", {
  variant: "tooltips.".concat(THEME_UI_DEFAULT_KEY),
  bg: 'secondary',
  color: 'white',
  fontSize: 'xs',
  borderRadius: 'none',
  boxShadow: 'primary.rise',
  elevation: 300
}), _defineProperty(_tooltips, "suite", {
  variant: "tooltips.".concat(THEME_UI_DEFAULT_KEY),
  bg: 'white',
  boxShadow: 'defaultRise'
}), _defineProperty(_tooltips, "peerDetail", {
  borderRadius: 'sm',
  boxShadow: 'primary.rise'
}), _defineProperty(_tooltips, "suppression", {
  variant: "tooltips.".concat(THEME_UI_DEFAULT_KEY),
  bg: 'neutrals.22',
  maxWidth: 280,
  border: '1px solid rgba(0,0,0,0.2)',
  boxShadow: 'textThick'
}), _defineProperty(_tooltips, 'info-tooltips', {
  bg: 'white',
  color: 'text',
  borderRadius: 0,
  fontSize: 'sm',
  p: 'lg',
  maxWidth: 350,
  minHeight: '32px',
  boxShadow: 'dropShadow',
  border: 'neutral.medium'
}), _tooltips);

export { tooltips };
//# sourceMappingURL=tooltips.esm.js.map
